export const PLAN_LABELS = {
  freemium: 'Freemium',
  learning_hub: 'Learning Hub',
  learning_hub_plus: 'Learning Hub+',
};

export const SEAT_FIELD_DEFS = [
  { key: 'seat_limit', label: 'Seat limit' },
  { key: 'seats_allocated', label: 'Seats allocated' },
  { key: 'seats_used', label: 'Seats used' },
  { key: 'seats_assigned', label: 'Seats assigned' },
  { key: 'seats_remaining', label: 'Seats remaining' },
  { key: 'seats_available', label: 'Seats available' },
];

export const hasSeatValue = (value) =>
  value !== undefined && value !== null && value !== '';

/** Learners get show_seats: false — never show seat fields on the learner strip. */
export const visibleSeatFields = (access) => {
  if (!access || access.show_seats === false) {
    return [];
  }
  return SEAT_FIELD_DEFS.filter(({ key }) => hasSeatValue(access?.[key])).map(({ key, label }) => ({
    key,
    label,
    value: access[key],
  }));
};

export const planLabel = (plan) => {
  if (!plan) {
    return '';
  }
  return PLAN_LABELS[plan] || String(plan).replace(/_/g, ' ');
};
